import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Proposal } from "../types/proposal.types";

export const generateProposalPDF = async (
  proposal: Proposal,
  returnBlob = false,
  selectedPages?: string[],
  isPrint = false,
): Promise<Blob | void> => {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
    compress: true,
  });

  const deceasedName =
    `${proposal.booking?.deceased?.[0]?.first_name || ""} ${proposal.booking?.deceased?.[0]?.surname || ""}`.trim();

  const allPages = [
    "cover",
    "main",
    "memorial",
    "frequently",
    "services",
    "service",
    "whatsapp",
    "agreement",
    "backpage",
  ];

  const pages =
    selectedPages && selectedPages.length > 0 ? selectedPages : allPages;

  for (let i = 0; i < pages.length; i++) {
    const element = document.getElementById(`${pages[i]}-page-pdf`);
    if (!element) continue;

    await new Promise((r) => setTimeout(r, 50));

    const canvas = await html2canvas(element, {
      scale: Math.max(2, window.devicePixelRatio || 1),
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");

    if (i > 0) doc.addPage();

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    const stretchPages = ["cover", "frequently"];
    const finalHeight = stretchPages.includes(pages[i])
      ? imgHeight < pageHeight
        ? pageHeight
        : imgHeight
      : imgHeight;

    doc.addImage(
      imgData,
      "PNG",
      0,
      0,
      imgWidth,
      finalHeight,
      undefined,
      "SLOW",
    );
  }

  if (returnBlob) {
    return doc.output("blob");
  }

  if (isPrint) {
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  } else {
    doc.save(
      `proposal-${proposal.eventTitle || deceasedName || "document"}.pdf`,
    );
  }

  //doc.save(`proposal-${proposal.eventTitle || deceasedName || "document"}.pdf`);
};
